<template>
  <div class="mobile-file-list-container">
    <div class="file-con">
      <template v-for="(item, index) in fileData">
        <div class="file-content-one" :key="index">
          <div class="file-title">
            {{item.dynamicName?`${item.fileMenuName}--${item.dynamicName}`:`${item.fileMenuName}`}}
          </div>
          <div class="file-second-content" v-if="item.children.length > 0">
            <template v-for="(fileParent, pIndex) in item.children">
              <div class="parent-one" :key="`second-${pIndex}`">
                <div class="parent-title">
                  <i class="el-icon-s-finance colors" v-if="fileParent.fileMenuSingle == 0"/>
                  <i class="el-icon-document colors" v-if="fileParent.fileMenuSingle == 1"/>
                  {{fileParent.fileMenuName}}
                </div>
                <div class="file-third-content" v-if="fileParent.children.length > 0">
                  <template v-for="(fileThird, thirdIndex) in fileParent.children">
                    <div class="file-one" :key="`third-${thirdIndex}`" @click="goFileUrl(fileThird)">
                      <div class="file-icon">
                        <i class="el-icon-document" />
                      </div>
                      <div class="file-content">
                        <div
                          class="file-name"
                          :class="{'redirect-span': fileInfo.isTarget}"
                        >
                          {{fileThird.fileMenuName}}
                        </div>
                        <div class="file-time" v-if="fileThird.files.length > 0">
                          {{fileThird.files[0].createTime}}&nbsp;{{fileThird.files[0].fileSize}}&nbsp;{{fileThird.files[0].userName}}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="file-third-content" v-if="fileParent.files.length > 0">
                  <template v-for="(fileInfo, fileIndex) in fileParent.files">
                    <div class="file-one" :key="`file-${fileIndex}`" @click="goFileUrl(fileInfo)">
                      <div class="file-icon">
                        <i class="el-icon-document" />
                      </div>
                      <div class="file-content">
                        <div
                          class="file-name"
                          :class="{'redirect-span': fileInfo.isTarget}"
                        >
                          {{fileInfo.fileName}}
                        </div>
                        <div class="file-time">
                          {{fileInfo.createTime}}&nbsp;{{fileInfo.fileSize}}&nbsp;{{fileInfo.userName}}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>
<script>
import { getFileMenuListByName } from "@/api/zd/dictionaries"
export default {
  name: 'MobileFileList',
  data() {
    return {
      fileData: [],
      levelOne: 0,
      bindLevel: {}
    }
  },
  props: {
    fileMenuUrlname: {
      required: true,
      type: String
    },

    fileMenuName: {
      required: true,
      type: String
    },

    fileOtherId: {
      required: true,
      type: String
    },

    onlySelf: {
      type: String,
      default: ''
    },
    dynamicId: {
      type: String,
      default: ''
    },
    flowableRootName: {
      type: String,
      default: undefined
    },
  },
  mounted() {
    // 查询附件列表
    this.queryFileList()
  },
  methods: {
    async queryFileList() {
      let params = {
        fileMenuUrlname:this.fileMenuUrlname,
        fileMenuName: this.fileMenuName,
        fileOtherId: this.fileOtherId,
        dynamicId:this.dynamicId,
      }
      if(this.onlySelf !== '') params.onlySelf = this.onlySelf
      if(this.flowableRootName !== '') params.flowableRootName = this.flowableRootName
      let res = await getFileMenuListByName(params)
      // console.info(res, 'getFileMenuListByName')
      if(res.data.code == 200) {
        let fileArray = res.data.data.filter(item => {return item.fileMenuName == this.fileMenuName})
        fileArray[0].children.map(item => {
          let findTarget = false
          if (item.files && item.files.length > 0 && item.fileMenuSingle != 1) {
                item.files.map((itemfiles) => {
                  if((itemfiles.fileUrl.indexOf('.pdf') > -1 ||
                      itemfiles.fileUrl.indexOf('.xls') > -1 ||
                      itemfiles.fileUrl.indexOf('.xlsx') > -1 ||
                      itemfiles.fileUrl.indexOf('.doc') > -1 ||
                      itemfiles.fileUrl.indexOf('.docx') > -1) &&
                      findTarget == false)
                  {
                    itemfiles.isTarget = true
                  }else {
                    itemfiles.isTarget = false
                  }
                })            
          }
        })
        this.fileData = fileArray
      }
    },
    extractNumberFromString(inputString) {
      const matches = inputString.match(/\d+/); // 使用正则表达式匹配数字
      if (matches) {
        return parseInt(matches[0], 10); // 将匹配到的字符串转换为整数
      } else {
        return null; // 如果没有匹配到数字，则返回 null 或其他适当的值
      }
    },    

    goFileUrl(fileInfo) {
      const isAndroid = /Android|Adr/.test(navigator.userAgent);
      const isiOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(navigator.userAgent);
      const firstFileUrl = fileInfo.fileUrl || (fileInfo.files.length > 0 && fileInfo.files[0].fileUrl);
      if (firstFileUrl) {
        let redirectUrl = this.isWord(firstFileUrl) ? `http://doc.taizhoujintou.com:18888/office/xdoc?doc=${firstFileUrl}` : firstFileUrl;
        // if (fileInfo.isTarget && !isAndroid && !isiOS) {
        //   redirectUrl = redirectUrl.replace('open', 'openall');
        // }
        if(isAndroid) {
          redirectUrl = firstFileUrl.indexOf('pdf')>0?`http://doc.taizhoujintou.com:18888/office/tohtml?pdf=${firstFileUrl}`:
                        firstFileUrl.indexOf('doc')>0?`http://doc.taizhoujintou.com:18888/office/tohtml?doc=${firstFileUrl}`:redirectUrl
          // 判断安卓文件大小
          const fileSize = this.extractNumberFromString(fileInfo.fileSize)
          // 文件大于5M提示PC端打开
          if(fileSize && fileSize/1024 > 5) {
            this.$message.warning('文件过大，请在PC端打开查看')
            return false
          }
        }
        window.open(redirectUrl)
      } else {
        this.$message({
          message: '该目录暂无上传附件',
          type: 'warning'
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-file-list-container{
  width: 100%;
  background-color: #f9f9f9;
  min-height: 75vh;
  overflow: auto;
  overflow-x: hidden;
  .redirect-span{
    text-decoration: underline;
    cursor: pointer;
  }  
  .file-con{
    width: 100%;
    height: 100%;
    // padding: 0rem .3rem;
    .file-content-one{
      .file-title{
        color: #51d351;
        font-size: .38rem;
        line-height: 1.2rem;
        padding: 0rem .3rem;
        border-bottom: 0.5px solid #f2f2f2;        
      }
      .file-second-content{
        background-color: #f9f9f9;
        // padding: 0rem .3rem 0 .6rem;
        font-size: .38rem;
        line-height: 1rem;
        border-bottom: 0.5px solid #f2f2f2;

      }
    }

    .parent-one{
      .parent-title{
        font-size: .38rem;
        padding: 0rem .3rem 0 .6rem;
        border-bottom: .5px solid #f2f2f2;
        border-top: 0.5px solid #f2f2f2;        
        i{
          color: #fec03d;
        }
      }
    }

    .file-third-content{
      padding: 0rem .3rem 0 .45rem;
      background-color: #fff;
      border-bottom: 0.5px solid #f2f2f2;
      border-top: 0.5px solid #f2f2f2;
      // height: 1.8rem;
      .file-one{
        display: flex;
        background-color: #fff;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 100%;
        height: 1.8rem;
        .file-icon{
          color: #333;
          font-size: .75rem;
          i{
            margin-right: 0.35rem;
            color: #999;
            font-size: .75rem;
          }
        }
        .file-content{
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .file-name{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: .55rem;
            font-size: .38rem;
            max-width: 80%;
            color: #333;
          }
          .file-time{
            font-size: .38rem;
            line-height: .55rem;
            color: #ccc;
          }
        }
      }
    }
  }
}
</style>